function getPrefix(path) {
  if (path.split('/')[1] === 'content') {
    return '/content/courses/'
  }
  return '/education/'
}

function subSectionUrl(path, courseId, sectionId, subSectionId) {
  return `${getPrefix(path)}${courseId}/section/${sectionId}/subsection/${subSectionId}`
}

export default {
  methods: {
    $_getCourseRoutePrefix(path) {
      return getPrefix(path)
    },
    $_getSectionUrl(path, content, section, isTest) {
      if (!isTest && section.subSections && section.subSections.length > 0) {
        if (section.id !== undefined && section.subSections
          && section.subSections[0].id !== undefined) {
          return `${getPrefix(path)}${content.id}/section/${
            section.id}/subsection/${section.subSections[0].id}`
        }
      } else if (isTest) {
        return `${getPrefix(path)}${content.id}/test/${
          section.id}`
      }
      return ''
    },
    $_getSubsectionUrl(path, courseContent, section, subSection) {
      return subSectionUrl(path, courseContent.id, section.id, subSection.id)
    },
    $_isLeavingCourse(to) {
      if (!(to.path.includes('courses') || to.path.includes('education'))) {
        return true
      }
      const split = to.path.split('/')
      if (split[split.length - 2] === 'courses' || split[split.length - 2] === 'education') {
        return true
      }
      return false
    },
    $_isLeavingTraining(to) {
      if (!(to.path.includes('training') || to.path.includes('education/training'))) {
        return true
      }
      const split = to.path.split('/')
      if (split[split.length - 2] === 'training' || split[split.length - 2] === 'education') {
        return true
      }
      return false
    },
    $_handleRoute(next, saved, updater) {
      if (!saved && updater > 0) {
        // eslint-disable-next-line no-alert
        const answer = window.confirm('Имеются несохранённые изменения. Вы точно хотите закрыть страницу?')
        if (answer) {
          window.onbeforeunload = undefined
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    }
  }
}
